import React, { ReactNode } from "react"
import { classNames } from "../../utils/helpers"
import Box from "../Box"
import Container from "../Container"

interface SectionImageProps {
  children?: ReactNode
  className?: string
  image: ReactNode
  reverse?: boolean
  imgClass?: string
  childClass?: string
}
const SectionImage = (props: SectionImageProps) => {
  const {
    children,
    className,
    image,
    imgClass,
    childClass,
    reverse = false,
    ...others
  } = props

  return (
    <Container
      fullWidthOnMobile={false}
      className={classNames(
        "flex w-full flex-col lg:flex-row gap-10 text-center lg:text-left",
        reverse && "lg:flex-row-reverse",
        className
      )}
      {...others}
      constrainedToBreakPoint
    >
      <Box
        className={classNames(
          image && !children ? "w-full" : "w-full ",
          imgClass ? imgClass : "lg:w-1/2"
        )}
      >
        {image}
      </Box>
      {children ? (
        <Box
          className={classNames("w-full", childClass ? childClass : "lg:w-1/2")}
        >
          {children}
        </Box>
      ) : null}
    </Container>
  )
}

export default SectionImage
